 
import { useEffect, useState } from 'react';

function defaultSortByFn(a, b) {
  // force null and undefined to the bottom
  a = a === null || a === undefined ? '' : a;
  b = b === null || b === undefined ? '' : b;
  // force any string values to lowercase
  a = typeof a === 'string' ? a.toLowerCase() : a;
  b = typeof b === 'string' ? b.toLowerCase() : b;
  // Return either 1 or -1 to indicate a sort priority
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  // returning 0, undefined or any falsey value will defer to the next
  // sorting mechanism or eventually the columns index via the orderByFn
  return 0;
}

export function sortBy(predicate) {
  let generatedPredicate;
  if (typeof predicate === 'string') {
    generatedPredicate = vals => vals[predicate];
  } else if (typeof predicate === 'function') {
    generatedPredicate = predicate;
  } else {
    throw new Error('Predicate must be a function or string');
  }
  return (a, b, desc) => defaultSortByFn(generatedPredicate(a), generatedPredicate(b), desc);
}

function matcher(predicates, testFn) {
  return (rows, id, filterValue) => {
    return rows.filter(row => {
      return [...predicates].some(predicate => {
        // Empty string matches all
        if (filterValue === '') return true;

        let value;
        if (typeof predicate === 'string') {
          value = row.original[predicate];
        } else if (typeof predicate === 'function') {
          value = predicate(row.original);
        } else {
          throw new Error('Predicate must be a function or string');
        }

        return !!value && testFn(String(value).toLowerCase(), String(filterValue).toLowerCase());
      });
    });
  };
}

export function filterByExactly(...args) {
  return matcher(args, (a, b) => a === b);
}

export function filterByContaining(...args) {
  return matcher(args, (a, b) => a.includes(b));
}

export function useControllableTable(defaultControls, defaultData, onControlsChangeCallback) {
  const data = {
    rows: [],
    pageCount: 0,
    totalRecordCount: 0,
    ...defaultData
  };

   
  const [{ sortBy, filters, pageIndex, pageSize }, setControls] = useState({
    sortBy: [],
    filters: [],
    pageIndex: 0,
    pageSize: 10,
    ...defaultControls
  });

  useEffect(() => {
    onControlsChangeCallback({ sortBy, filters, pageIndex, pageSize });
  }, [sortBy, filters, pageIndex, pageSize, onControlsChangeCallback]);

  return {
    defaultSortBy: sortBy,
    defaultFilters: filters,
    defaultPageIndex: pageIndex,
    pageSize,
    data: data.rows,
    pageCount: data.pageCount,
    totalRecordCount: data.totalRecordCount,
    onControlsChange: setControls,
    serverPagination: true,
    disablePageResetOnDataChange: true
  };
}
